import React from 'react'
import {
  IconLockNew20,
  Tooltip,
} from '@lightspeed/unified-components-helios-theme/react'
import { useUcPortalTarget } from '../../../shared/useUcPortalTarget'
import { useLockedCustomerIconModel } from './useLockedCustomerIconModel'

export const LockedCustomerIcon: React.FC = () => {
  const { tooltipInfo } = useLockedCustomerIconModel()
  const { portalTargetRef } = useUcPortalTarget()

  if (!tooltipInfo) {
    return null
  }

  return (
    <div className="uc-base">
      <div className="p-3">
        <Tooltip
          placement="bottom-end"
          portalTargetRef={portalTargetRef}
          closeDelay={200}
          customClasses={{
            content: ['max-w-80'],
          }}
          controlSlot={<IconLockNew20 data-testid="customer-locked-icon" />}
        >
          <strong>{tooltipInfo.title}</strong>
          <div>{tooltipInfo.message}</div>
        </Tooltip>
      </div>
    </div>
  )
}
